import {useMutation} from "@tanstack/react-query";

import {editRepresentativeContactMutationOptions} from "./edit-representative-contact.mutation-options";

export function useEditRepresentativeContact(representativeId: string, contactId: number) {
  return useMutation(editRepresentativeContactMutationOptions(representativeId, contactId));
}
